import { NoResults } from "../../NoResults/NoResults.js";
import { AuditLogTableHeadRow } from "./TableHeadRow.js";
import { AuditLogTableRow } from "./TableRow.js";
import "react";
import { DinnerTable, Pagination } from "@therms/atalaya";
import { Fragment as Fragment$1, jsx, jsxs } from "react/jsx-runtime";
//#region src/components/AuditLogs/AuditLogTable/index.tsx
function AuditLogTable({ data, recordsPerPage, setRecordsPerPage, setSkippedRecords, showUser, skippedRecords, totalRecords }) {
	return /* @__PURE__ */ jsx("div", {
		className: "pr-xs relative",
		children: data?.total ? /* @__PURE__ */ jsxs(Fragment$1, { children: [/* @__PURE__ */ jsxs(DinnerTable, { children: [/* @__PURE__ */ jsx(AuditLogTableHeadRow, { showUser }), /* @__PURE__ */ jsx(DinnerTable.Body, { children: data?.auditLogs.map((log, index) => /* @__PURE__ */ jsx(AuditLogTableRow, {
			showUser,
			rowData: log
		}, `${log.date}${index}`)) })] }), /* @__PURE__ */ jsx(Pagination, {
			onPageClick: setSkippedRecords,
			onSetRecordsPerPage: setRecordsPerPage,
			recordsPerPage,
			showDescription: true,
			skippedRecords,
			totalRecords
		})] }) : /* @__PURE__ */ jsx(NoResults, { text: "No Audit Logs" })
	});
}
//#endregion
export { AuditLogTable };

//# sourceMappingURL=index.js.map